import React, { useState, useEffect } from 'react'
import styles from './SitOutBottomNotice.module.css'
import { doesExist } from '../../../Common/utils/GameUtils'
import useGameSocket from '@/src/hooks/utils/useGameSocket';

export default function SitOutBottomNotice({ playerSitOutTimer, playerSeat, tempTableId }) {
    const [timeLeft, setTimeLeft] = useState('');
    const { sendSitInProtocol } = useGameSocket(tempTableId);

    // console.log('Spruha log >>> Player Sit Out Timer is >>> ', playerSitOutTimer, doesExist(playerSeat));

    useEffect(() => {
        if (!playerSitOutTimer) return;

        const updateTimer = () => {
            const now = Math.floor(Date.now() / 1000); // Current time in seconds
            const deadline = Math.floor(playerSitOutTimer / 1000); // Convert deadline to seconds if it's in milliseconds
            const difference = deadline - now;

            if (difference <= 0) {
                setTimeLeft('00:00');
                return;
            }

            const minutes = Math.floor(difference / 60);
            const seconds = difference % 60;
            
            // Format as mm:ss with leading zeros
            const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            setTimeLeft(formattedTime);
        };

        // Update immediately
        updateTimer();

        // Update every second
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [playerSitOutTimer]);

    return playerSitOutTimer && doesExist(playerSeat) ? (
            <div className={styles.sitInSitOutNotice}>
                <div className={styles.sitInSitOutNoticeText}>
                    You have <span className={styles.sitInSitOutNoticeTextTime}>{timeLeft}</span> to join the game.
                </div>
                <div onClick={sendSitInProtocol} className={styles.sitInSitOutNoticeButton}>
                    I'm back
                </div>
            </div>
    ) : null
}
